export const extensionsVisibilityReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SHOW_Extension':
            return action.payload;
        default:
            return state;
    }
};
